/** Current-time indicator line overlay for a day column time grid. */
import { Box } from '@mui/material';

const DayColumnNowLine = ({ topPosition, isToday }) => (
  <Box
    sx={{
      position: 'absolute',
      left: 0,
      right: 0,
      height: 2,
      bgcolor: isToday ? 'primary.main' : 'rgba(148, 163, 184, 0.3)',
      zIndex: 10,
      pointerEvents: 'none',
      top: `${topPosition}px`,
    }}
    key="current-time-line"
    data-testid="now-line"
  />
);

export default DayColumnNowLine;
